import { Guid } from "@/types";

export enum SupplierType {
    unknown = "unknown",
    thirdParty = "thirdParty",
    affiliatedCompany = "affiliatedCompany"

}

export interface IGetSupplierDto {
    id: Guid
    number: string
    name: string
    type: SupplierType
}

export default class Supplier {
    id: Guid
    number: string
    name: string
    type: SupplierType

    constructor({ id, number, name, type }: IGetSupplierDto) {
        this.id = id
        this.number = number
        this.name = name
        this.type = type
    }
}
